import React, { ReactNode } from 'react'
import { CloseOutlined } from '@ant-design/icons'
import { Select, Tag, Popover, Flex, Form } from 'antd'
import { filterOption } from 'src/pages/budget/utils'
import { REQUIRED_FIELD } from 'src/pages/budget/const'

type UsersSelectProps = {
  label: string | ReactNode | null
  options: { label: string; value: string }[]
  name: string
  form: any
}

export const ItemSelectUsers = ({
  name,
  form,
  options,
  label,
}: UsersSelectProps) => {
  const { Item } = Form


  return (
    <Item
      label={label}
      required={false}
      rules={[
        {
          required: true,
          message: REQUIRED_FIELD,
        },
      ]}
      name={name}
    >
      <Select
        mode="multiple"
        placeholder="Выбрать..."
        maxTagCount={10}
        style={{ width: '100%' }}
        options={options}
        filterOption={filterOption}
        maxTagPlaceholder={(omittedValues) => (
          <Popover
            trigger="click"
            placement="bottom"
            content={
              <Flex
                wrap
                gap="small"
                onMouseDown={(e) => e.stopPropagation()}
                style={{ maxWidth: 600, maxHeight: 200, overflowY: 'auto' }}
              >
                {omittedValues.map((item) => (
                  <Tag
                    key={item.value}
                    style={{ fontSize: 14 }}
                    closable
                    closeIcon={<CloseOutlined />}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClose={(e) => {
                      e.preventDefault()
                      const current = form.getFieldValue(name) || []
                      form.setFieldValue(
                        name,
                        current.filter((v: string) => v !== item.value),
                      )
                    }}
                  >
                    {String(item.label)}
                  </Tag>
                ))}
              </Flex>
            }
          >
            <Tag
              style={{ cursor: 'pointer' }}
              onMouseDown={(e) => e.stopPropagation()}
            >
              +{omittedValues.length}
            </Tag>
          </Popover>
        )}
      />
    </Item>
  )
}
